import Et3Button from "../../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";

const LoadMoreComments = withLiteObserverAndTheme(() => {
  const showLoadMore = getUserAdvancedStore().showLoadMore.get();

  return showLoadMore ? (
    <Et3Button
      isEnabled={true}
      onClick={async () => await getUserAdvancedStore().getNewLoadComments()}
      size="MEDIUM"
      type="GET"
      text="LOAD_MORE"
    />
  ) : null;
});
export default LoadMoreComments;
